import CustomDropdown from "../../../../../components/common/Dropdown/CustomDropDown"
import FilterInTable from "../../../../Manage/FilterInTable"
import { Button } from "reactstrap"
import styles from "./All.module.scss"
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent"
import { useNavigate } from "react-router-dom"
import WholesalerDropdown from "../../../../../components/WholesalerComponents/WholesalerDropdown/WholesalerDropdown"

const All = () => {
  const navigate = useNavigate()

  const data = [
    {
      couponCode: "COUPON10",
      couponType: "Percentage off",
      validityPeriod: "30 March - 7 April",
      discount: "20%",
      conditions: ["Min.spent: 20$", "1 per customer"],
      applicability: "Electronics",
      used: " 20 / 100",
      status: "Active",
    },
    {
      couponCode: "COUPON10",
      couponType: "Percentage off",
      validityPeriod: "30 March - 7 April",
      discount: "20%",
      conditions: ["Min.spent: 20$", "1 per customer"],
      applicability: "Electronics",
      used: " 20 / 100",
      status: "Active",
    },
    {
      couponCode: "COUPON10",
      couponType: "Percentage off",
      validityPeriod: "30 March - 7 April",
      discount: "20%",
      conditions: ["Min.spent: 20$", "1 per customer"],
      applicability: "Electronics",
      used: " 20 / 100",
      status: "Deactivated",
    },
    {
      couponCode: "COUPON10",
      couponType: "Percentage off",
      validityPeriod: "30 March - 7 April",
      discount: "20%",
      conditions: ["Min.spent: 20$", "1 per customer"],
      applicability: "Electronics",
      used: " 20 / 100",
      status: "Active",
    },
    {
      couponCode: "COUPON10",
      couponType: "Percentage off",
      validityPeriod: "30 March - 7 April",
      discount: "20%",
      conditions: ["Min.spent: 20$", "1 per customer"],
      applicability: "Electronics",
      used: " 20 / 100",
      status: "Ended",
    },
  ]

  const handleClick = () => {
    navigate("/marketing-options/edit-coupon")
  }

  const columns = [
    {
      name: "Coupon Code",
      selector: (row) => row.couponCode,
    },
    {
      name: "Coupon type",
      selector: (row) => row.couponType,
    },
    {
      name: "Validity Period",
      selector: (row) => row.validityPeriod,
    },
    {
      name: "Discount",
      selector: (row) => row.discount,
    },
    {
      name: "Conditions",
      cell: (row) => (
        <div>
          {row.conditions.map((item) => (
            <div>{item}</div>
          ))}
        </div>
      ),
    },
    {
      name: "Applicability",
      selector: (row) => row.applicability,
    },
    {
      name: "Used",
      selector: (row) => row.used,
    },
    {
      name: "Status",
      selector: (row) => {
        let color
        switch (row.status) {
          case "Active":
            color = "#41B8E4"
            break
          case "Deactivated":
            color = "#EC7426"
            break
          case "Ended":
            color = "black"
            break
          default:
            color = "black"
            break
        }
        return <span style={{ color: color }}>{row.status}</span>
      },
    },
    {
      name: "Action",
      cell: (row) => {
        const options = {
          "Active": ["Edit", "Deactivate"],
          "Deactivated": ["Edit", "Activate"],
          "Ended": ["Delete"]
        }
        return <WholesalerDropdown options={options[row.status]} setSelectedAction={handleClick} />
      },
    },
  ]

  return (
    <div className="p-3 bg-white">
      <FilterInTable componentName="Coupons All" />
      <div className="mt-3">
        <DatatableComponent data={data} columns={columns} type={"gray-bordered"} />
      </div>
      <div className="d-flex justify-content-center">
        <div className={styles.addProductBtnContainer}>
          <div className={styles["add-product-btn"]}>Cancel</div>

          <Button type="button" color="primary" className={styles.productBtn} onClick={() => {}}>
            Add Coupon
          </Button>
        </div>
      </div>
    </div>
  )
}

export default All
